import React from "react";
import {
  Box,
  Stack,
  Button,
  Typography,
  Grid,
  Divider,
  Container,
  Paper,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";

const Maps = () => {
  return (
    <Box>
      {/* Hero */}
      <Paper
        elevation={0}
        sx={{
          bgcolor: "#5D0096",
          color: "white",
          borderRadius: 0,
          py: 6,
          mb: 4,
        }}
      >
        <Container maxWidth="lg">
          <Stack
            spacing={3}
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <img
              src="/images/uw-crest.png"
              alt="University of Waterloo Crest"
              style={{ maxHeight: "100px" }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "2.2rem", md: "3rem" },
                textShadow: "2px 2px 4px rgba(0,0,0,0.25)",
              }}
            >
              Our Waterloo Campus
            </Typography>
            <Typography
              variant="h5"
              sx={{ maxWidth: 900, lineHeight: 1.9, opacity: 0.95 }}
            >
              Navigating a large university campus like Waterloo can be an
              exciting adventure. With over 30 different buildings spread across
              the campus, each housing different faculties and departments, it's
              important to have a guide to make sure you don't get lost!
            </Typography>

            <Button
              variant="contained"
              size="large"
              endIcon={<MapIcon />}
              onClick={() => window.open("https://uwaterloo.ca/map/")}
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                color: "white",
                border: "2px solid rgba(255,255,255,0.3)",
                borderRadius: 3,
                px: 4,
                py: 1.5,
                fontSize: "1.1rem",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.3)",
                  borderColor: "rgba(255,255,255,0.5)",
                },
              }}
            >
              View our Campus Map
            </Button>
          </Stack>
        </Container>
      </Paper>

      {/* Washrooms Section */}
      <Container maxWidth="lg" sx={{ pb: 6 }}>
        <Paper elevation={2} sx={{ p: { xs: 2.5, md: 4 }, borderRadius: 4 }}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={2}
          >
            <Stack spacing={1} alignItems="center" sx={{ width: "100%" }}>
              <Typography variant="h3" align="center" gutterBottom>
                Washroom Locations on Waterloo Campus
              </Typography>
              <Divider sx={{ width: "100%" }} />
            </Stack>
          </Box>

          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="stretch"
          >
            {/* Engineering Accessible Washrooms */}
            <Grid item xs={12} md={6}>
              <Card
                elevation={3}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                  <Stack spacing={1.5} alignItems="center" textAlign="center">
                    <Typography variant="h4" align="center">
                      Engineering Accessible Washrooms
                    </Typography>
                    <Typography
                      variant="body1"
                      align="center"
                      sx={{ lineHeight: 1.9 }}
                    >
                      Looking for Wheelchair Accessible or Gender Inclusive
                      washrooms? This is your best resource for finding
                      washrooms inside the Engineering buildings.
                    </Typography>
                  </Stack>
                </CardContent>
                <CardActions sx={{ p: 2.5, pt: 0 }}>
                  <Box width="100%" display="flex" justifyContent="center">
                    <Button
                      variant="contained"
                      color="engSecondary"
                      onClick={() =>
                        window.open(
                          "https://uwaterloo.ca/engineering-equity-diversity/washroom-accessibility-0",
                        )
                      }
                      sx={{
                        fontSize: "1em",
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                      }}
                    >
                      Find a Washroom in Eng Buildings
                    </Button>
                  </Box>
                </CardActions>
              </Card>
            </Grid>

            {/* Campus All Gender Washrooms */}
            <Grid item xs={12} md={6}>
              <Card
                elevation={3}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                  <Stack spacing={1.5} alignItems="center" textAlign="center">
                    <Typography variant="h4" align="center">
                      Campus All Gender Washrooms
                    </Typography>
                    <Typography
                      variant="body1"
                      align="center"
                      sx={{ lineHeight: 1.9 }}
                    >
                      Outside the Engineering buildings, there are plenty of
                      inclusive washrooms too! Check out the comprehensive
                      campus-wide All-Gender Washroom list for convenient and
                      accessible spaces regardless of your gender identity.
                    </Typography>
                  </Stack>
                </CardContent>
                <CardActions sx={{ p: 2.5, pt: 0 }}>
                  <Box width="100%" display="flex" justifyContent="center">
                    <Button
                      variant="contained"
                      color="engSecondary"
                      onClick={() =>
                        window.open(
                          "https://uwaterloo.ca/equity-diversity-inclusion-anti-racism/washrooms-list",
                        )
                      }
                      sx={{
                        fontSize: "1em",
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                      }}
                    >
                      Find a Washroom around Campus
                    </Button>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default Maps;
